import { cn } from "@utils/tailwind.util";

interface Props {
  className?: string;
}

export function NoteEditorSkeleton({ className }: Props) {
  return (
    <div className={cn("min-h-[100px] flex flex-col gap-4 animate-pulse", className)}>
      <div className="w-full h-[12px] bg-gray-300 dark:bg-gray-500 rounded-lg" />
      <div className="w-full h-[12px] bg-gray-300 dark:bg-gray-500 rounded-lg" />
      <div className="w-full h-[12px] bg-gray-300 dark:bg-gray-500 rounded-lg" />
      <div className="w-[150px] h-[12px] bg-gray-300 dark:bg-gray-500 rounded-lg" />
    </div>
  );
}
